<template>
  <div>
    <section>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell">
          <h2>Teaser</h2>
        </div>
        <div class="o-grid__cell top-buttons">
          <bos-button @click="newTeaser">Neuer Teaser</bos-button>
        </div>
      </div>
      <bos-overview-table
        :data="teasers"
        :columns="[
          {
            key: 'typeName',
            name: 'Typ'
          },
          {
            key: 'internalName',
            name: 'Name'
          }
        ]"
        deleteTitle="Teaser löschen"
        :deleteText="
          obj =>
            'Soll der Teaser <b>&quot;' +
            obj.internalName +
            '&quot;</b> vom Typ <b>&quot;' +
            obj.typeName +
            '&quot;</b> wirklich gelöscht werden?'
        "
        :onEdit="editTeaser"
        :onDelete="deleteTeaser"
      />
    </section>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService'
import BosButton from '@/components/BosButton'
import BosOverviewTable from '@/components/BosOverviewTable'

export default {
  name: 'AdminBegin',
  components: { BosButton, BosOverviewTable },
  data() {
    return {
      teasers: []
    }
  },
  methods: {
    newTeaser: function() {
      this.$router.push({
        name: 'AdminAdvertisingCreate',
        hash: '#typ'
      })
    },
    editTeaser: function(teaser) {
      this.$router.push({
        name: 'AdminAdvertisingEdit',
        params: {
          id: teaser._id
        }
      })
    },
    deleteTeaser: function(teaser) {
      ApiService.deleteTeaser(teaser._id).then(() => {
        this.teasers = this.teasers.filter(item => {
          return item._id != teaser._id
        })
      })
    },
    getTeaserListing() {
      ApiService.getTeasersOverview().then(response => {
        ApiService.getTeaserTypes().then(response2 => {
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].typeName = response2.data.filter(function(item) {
              return item.value == response.data[i].type
            })[0].text
          }
          this.teasers = response.data //filter(response.data, { state: 'open' })
        })
      })
    }
  },
  mounted() {
    this.getTeaserListing()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

section {
  margin-bottom: 6rem;
}

.create-teaser-wrapper {
  > div {
    float: left;
  }

  &:after {
    display: block;
    content: '';
    clear: both;
  }
}

.top-buttons {
  float: right;
  text-align: right;
  padding-top: 20px;

  button {
    margin-right: 1.333rem;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
